// Missing settings in older configurations have the same defaults as new ones.
export function pageSettings(configuration) {
  const legacyPackingListEnabled = configuration?.settings?.pageFeatures?.packingList ?? configuration?.settings?.packingListDisplay !== 'hidden';
  const configuredPackingListDisplay = configuration?.settings?.packingListDisplay;
  const packingListDisplay = ['belowForm', 'belowImage', 'hidden'].includes(configuredPackingListDisplay)
    ? configuredPackingListDisplay
    : legacyPackingListEnabled ? 'belowImage' : 'hidden';
  return {
    formStyle: ['blocks', 'advanced'].includes(configuration?.settings?.formStyle) ? configuration.settings.formStyle : 'simple',
    packingListDisplay,
    packingListTitle: typeof configuration?.settings?.packingListTitle === 'string' ? configuration.settings.packingListTitle : '',
    requireTermsAcceptance: configuration?.settings?.requireTermsAcceptance === true,
    pageFeatures: {
      productSwitcher: configuration?.settings?.pageFeatures?.productSwitcher === true,
      packingList: packingListDisplay !== 'hidden',
      notices: (configuration?.settings?.pageFeatures?.notices ?? configuration?.settings?.pageFeatures?.disclaimers) === true,
    },
  };
}

export function validatePageSettings(settings) {
  if (settings === undefined) return [];
  if (!settings || typeof settings !== 'object' || Array.isArray(settings)) return ['Settings must be an object.'];
  const errors = [];
  if (settings.packingListTitle !== undefined && typeof settings.packingListTitle !== 'string') errors.push('Component list title must be a string.');
  if (settings.formStyle !== undefined && !['simple', 'advanced', 'blocks'].includes(settings.formStyle)) errors.push('Form style must be simple, advanced, or blocks.');
  if (settings.packingListDisplay !== undefined && !['belowForm', 'belowImage', 'hidden'].includes(settings.packingListDisplay)) errors.push('Packing list display must be belowForm, belowImage, or hidden.');
  if (settings.requireTermsAcceptance !== undefined && typeof settings.requireTermsAcceptance !== 'boolean') errors.push('Require terms acceptance must be a boolean.');
  const features = settings.pageFeatures;
  if (features !== undefined) {
    if (!features || typeof features !== 'object' || Array.isArray(features)) errors.push('Page features must be an object.');
    else for (const key of ['productSwitcher', 'packingList', 'notices', 'disclaimers']) {
      if (features[key] !== undefined && typeof features[key] !== 'boolean') errors.push(`${key} must be a boolean.`);
    }
  }
  return errors;
}
